import React, { useEffect, useState } from "react";
import data from "../data/contactPageData.json";

const ContactPage = () => {
  const [pageData, setpageData] = useState({});
  useEffect(() => {
    setpageData(data.Contact[0]);
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://forms.webservio.net/static_files/js/form.widget.js";
    script.async = true;

    script.onload = () => {
      try {
        new window.EasyForms().initialize({
          id: 18,
          container: "action-form",
          height: "751px",
          form: "//forms.webservio.net/app/embed"
        }).display();
      } catch (e) {
        console.error("EasyForms failed to load:", e);
      }
    };

    document.body.appendChild(script);

    // Cleanup if needed
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
        <div className="page-title">
          <div className="container py-5">
            <h2 className="title position-relative">{pageData.title}</h2>
            <p>{pageData.subTitle}</p>
          </div>
        </div>  

        <section className="form-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-8 offset-md-3 form-wrap shadow-sm">
                <div id="action-form"></div>
              </div>
            </div>
          </div>
        </section>

    </>
  );
};

export default ContactPage;
